import { gql } from "@apollo/client";

export const CreateCategoryOption = gql`
  mutation CreateCategoryOption($data: CreateCategoryOptionInput!) {
    createCategoryOption(data: $data) {
      name
      organization {
        id
      }
      type
    }
  }
`;

export const DeleteCategoryOption = gql`
  mutation DeleteCategoryOption($deleteCategoryOptionId: String!) {
    deleteCategoryOption(id: $deleteCategoryOptionId)
  }
`;

export const UpdateCategoryOption = gql`
  mutation UpdateCategoryOption(
    $data: UpdateCategoryOptionInput!
    $updateCategoryOptionId: String!
  ) {
    updateCategoryOption(data: $data, id: $updateCategoryOptionId) {
      id
    }
  }
`;
